import React from 'react';

import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getVideo } from '../../../../utils/videoDB';

const SplashClosedVideoLoop = ({ videoRef, videoKey, removeWhiteFlashOnVideo = true }) => {
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    let objectUrl = null;

    const fetchAndLoadVideo = async () => {
      try {
        const splashdecodedUrl = decodeURIComponent(videoKey);
        const splashfileName = splashdecodedUrl.split('/').pop();
        const result = await getVideo(splashfileName);
        const blob = result?.blob;

        if (blob && blob instanceof Blob) {
          objectUrl = URL.createObjectURL(blob);
          setVideoSrc(objectUrl);
          console.log('blobUrl', objectUrl);
        } else {
          console.error('Invalid blob:', blob);
          setVideoSrc(videoKey);
        }
      } catch (err) {
        console.error('Error loading video:', err);
      }
    };

    fetchAndLoadVideo();
    console.log('updated');

    return () => {
      if (videoRef?.current) {
        videoRef.current.pause();
        videoRef.current.removeAttribute('src');
        videoRef.current.load();
      }
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
      setVideoSrc('');
    };
  }, [videoKey]);

  const motionProps = removeWhiteFlashOnVideo
    ? {}
    : {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 2 },
      };

  const handleVideoPlayPage = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = false;
    }
  };

  const handleVideoEnd = () => {
    videoRef.current.play();
  };

  return (
    <motion.video
      ref={videoRef}
      className="position-absolute top-0 start-0 w-100 video-menu  object-fit-cover"
      src={videoSrc}
      muted
      preload="auto"
      autoPlay
      onPlay={handleVideoPlayPage}
      onEnded={handleVideoEnd}
      loop={true}
      style={{
        zIndex: 1,
      }}
      {...motionProps}
    />
  );
};

export default SplashClosedVideoLoop;
